class LeafletControlInterface {

  constructor (positionMapAtUserPosition, positionMapAtLocation, hasUserPosition, centerAroundPois, showPopup, getUserPosition) {
    this.getUserPosition = getUserPosition
    this.positionMapAtUserPosition = positionMapAtUserPosition
    this.positionMapAtLocation = positionMapAtLocation
    this.hasUserPosition = hasUserPosition
    this.centerAroundPois = centerAroundPois
    this.showPopup = showPopup
  }

}

export default LeafletControlInterface



// WEBPACK FOOTER //
// ./src/components/Leaflet/LeafletControlInterface.js